import { Input } from "../../../lib/Input";
import { Time } from "../../../lib/Time";
import { Physics } from "../../../math/Physics";
import Gun from "../../Gun";
import Player from "../../Player";

export default class RepairBeam extends Gun {
    target: Player|undefined;

    constructor(player: Player) {
        super(player, {
            damage: 50,
            fireRate: 1,
            magSize: 1,
            reloadTime: 2,
            bulletSpeed: 400,
            mouseTrigger: 2
        });
    }

    ActiveUpdate() {
        if (!this.target || (this.mouseTrigger != undefined && Input.GetMouseButtonUp(this.mouseTrigger))) {
            this.target = undefined;
            return;
        }

        this.player.UseUnergy(5*Time.deltaTime);

        this.player.engine.sendDamagePacket(this.target, -50 * Time.deltaTime);
    }

    Update(): void {
        if (!this.player.isOwner || this.player.isDead) return;

        if (this.mouseTrigger != undefined && Input.GetMouseButton(this.mouseTrigger)) {
            const validPlayers = this.player.engine.GetGameObjectsBehaviors<Player>(Player).filter(
                v => !v.isDead && v.team && v.team === this.player.team
            );

            for (const player of validPlayers) {
                if (Physics.CircleCircleCollision({
                    position: player.transform.position,
                    radius: player.size
                }, {
                    position: this.player.engine.mouseWorldPosition,
                    radius: 32
                }) !== false) {
                    this.target = player;
                    break;
                }
            }
        }

        if (this.target) {
            this.ActiveUpdate();
        }
    }

    Draw(yOffset: number): void {
        if (this.player.isOwner) {
            this.player.ctx.strokeStyle = '#55ff5530';
            this.player.ctx.lineWidth = 1;
            this.player.engine.StrokeCircle(this.player.engine.mouseWorldPosition, 32);
        }

        if (this.target) {
            this.player.engine.Line(this.player.transform.position, this.target.transform.position);
        }
    }
}